<template>
  <div id="playground">
    <vc-calendar @dayclick="onDayClick" is-expanded :attributes='attrs' :rows="2" :columns="$screens({ default: 1, lg: 2 })" />
      <v-dialog v-model="selectedOpen" eager transition="dialog-bottom-transition"  width="unset" offset-x>
        <v-card color="grey lighten-4" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-btn icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-toolbar-title >{{selectedDay}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <h1>Signature</h1>
            <div id="VueSignaturePad">
              <VueSignaturePad :customStyle="signatureStyle" height="200px" ref="signaturePad" />
              <div>
                <v-btn text color="primary" @click="save">Save</v-btn>
                <v-btn text color="secondary" @click="undo">Undo</v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    <div>
      <qrcode-scanner :qrbox="250" :fps="10" @result="onScan" />
      <br />
      <universal-input v-model="numericInputValue" :config="config" />
      <div>
        {{debugMessage}}
      </div>
    </div>
  </div>
</template>

<script>
import UniversalInput from '@/components/CRUD/UniversalInput'
import { ref, onMounted } from 'vue'
import QrcodeScanner from '@/components/QRCode/QrcodeScanner.vue'
// import VueSignaturePad from 'vue-signature-pad';
export default {
  components: {
    QrcodeScanner,
    UniversalInput,
    // VueSignaturePad
  },
  data() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    return {
      debugMessage:'',
      signatureStyle:{
        border: 'black 3px solid '
      },
      selectedDay: '',
      attrs: [
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        },
        {
          highlight: {
            color: 'purple',
            fillMode: 'light',
          },
          dates: new Date(year, month, 13),
        },
        {
          highlight: {
            color: 'purple',
            fillMode: 'outline',
          },
          dates: new Date(year, month, 14),
        },
      ],
      selectedOpen: false,
      selectedElement: null,
      selectedEvent: {},
      numericInputValue: null,
      config: {
        propName: 'name',
        label: 'Dessert name',
        type: {
          inputType: 'number',
        },
      },
      focus: '',
    }
  },
  computed: {
    lastMonth(){
      let x = new Date();
      x.setDate(0); // 0 will result in the last day of the previous month
      x.setDate(20); // 1 will result in the first day of the month
      let dateString = x.toISOString().split('T')[0]
      return dateString
    }
  },
  methods: {
    onDayClick(day) {
      console.log(day)
      this.selectedDay = day.id
      this.showEvent()
    },
    undo() {
      this.$refs.signaturePad.undoSignature()
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      console.log(isEmpty)
      console.log(data)
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      console.log('prev')
      this.$refs.calendarCurrMonth.prev()
      this.$refs.calendarLastMonth.prev()

    },
    next() {
      console.log('next')
      this.$refs.calendarCurrMonth.next()
      this.$refs.calendarLastMonth.prev()
    },
    showEvent(
      // { nativeEvent, event }
    ) {
      // console.log('showEvent', event)
      const open = () => {
        // this.selectedEvent = event
        // this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.selectedOpen = true
          this.$nextTick(() => {
            this.$refs.signaturePad.resizeCanvas()
          })
        }))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      // nativeEvent.stopPropagation()
    },
    onScan(decodedText, decodedResult) {
      // handle the message here :)
      console.log('onScan decodedText, decodedResult', decodedText, decodedResult)
      alert(`scan result: ${decodedText}` )
    },
  },
  setup() {
    // const calendar = ref(null)
    const signaturePad = ref(null)
    // onMounted(() => {
    //   console.log('calendar', calendar)
    //   calendar.value.scrollToTime('08:00')
    // })
    const today = ref(new Date().toISOString().substring(0, 10))
    const events = ref([
      {
        name: 'Weekly Meeting',
        start: '2022-10-30 09:00',
        end: '2022-10-30 13:00',
      },
    ])
    return {
      signaturePad,
      QrcodeScanner,
      // calendar,
      today,
      events,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
.btn-toggle {
  flex-direction: column;
}
</style>
